/**
 * Retire des paramètres de l'URL courante une fois qu'ils ont été traités (liens directs vers une
 * fiche) : sans cela, la fiche se rouvrirait à chaque remontage de la page. Aucune navigation.
 */
export function removeUrlParams(names) {
    try {
        const url = new URL(window.location.href);
        let changed = false;
        names.forEach((name) => {
            if (url.searchParams.has(name)) {
                url.searchParams.delete(name);
                changed = true;
            }
        });
        if (changed) {
            window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        }
    } catch (e) {
        // URL ou History API indisponible : sans effet, la fiche pourra se rouvrir.
    }
}
